import * as React from "react";
import {authorize, IWithRouterProps, Overlay, withRouter} from "@athena-portal/components";
import FalconHeader from "../../../../../components/navigation/FalconHeader";
import {PluginTemplates} from "../../../../../utils/PluginTemplates";
import FalconFooter from "../../../../../components/navigation/FalconFooter";
import {lazyInject} from "@athena-portal/core";
import {ClaimsTable} from "./ClaimsTable";
import {ICustomerPortalService,Policy,Types,IncludedProductsEnum, productHelper, FalconNavigatorHeader} from "@falcon/services";
import { scrollToTop } from "../../../../../CommonFunctions";

interface IState {
    policies: Policy[];
    policiesLoaded: boolean;
}

@authorize
export class ClaimsPagePlain extends React.Component<IWithRouterProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    private pluginTemplates = new PluginTemplates();

    constructor(props: IWithRouterProps) {
        super(props);

        this.state = {
            policies: [],
            policiesLoaded: false
        }
    }

    public componentDidMount(): void {
        scrollToTop();
        this.pluginTemplates.setPageTitle("Your claims");

        this.customerPortalService.getPolicies().subscribe((policies: Policy[]) => {
            this.setState({
                policies,
                policiesLoaded: true
            });
        });
    }

    public render() {
        return (
            <React.Fragment>

                <FalconHeader/>
                <div className="page-contents">
                    <FalconNavigatorHeader
                        back="/dashboard"
                        title="Claims"
                        />
                    <div className="section-panel">
                        <div className="section">
                            <img className="main-icon" src="/img/Flow-make-a-claim.svg" alt="Make a claim"
                                 aria-label="Make a claim" tabIndex={0}/>
                            <button type="button"
                                    className="btn btn-primary btn-next plugin mb-0" onClick={this.handleRedirect}>
                                Make a claim
                            </button>
                        </div>
                        <ClaimsTable/>
                        <Overlay show={!this.state.policiesLoaded}/>
                    </div>
                    {this.pluginTemplates.renderBackLink("Back", false, "/dashboard")}
                </div>
                <FalconFooter/>


            </React.Fragment>
        );
    }

    private handleRedirect = (event: any): void => {
        const includedProductsEnum: IncludedProductsEnum = productHelper.getIncludedProducts(this.state.policies);
        if (this.state.policies.length > 1){
            this.props.navigate("/dashboard/selectCoverage");
        } else if (includedProductsEnum === IncludedProductsEnum.MOTOR){
            this.props.navigate("/dashboard/windscreen");
        } else if (includedProductsEnum === IncludedProductsEnum.RENTERS){
            this.props.navigate("/dashboard/rentersClaims/new");
        }
    };
}

export const ClaimsPage = withRouter(ClaimsPagePlain)
